
    <div id="dropZone"  [className]="customstyle" [class.over]="dragoverflag"
        (drop)="dropFiles($event)"
        (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
        <div class="content">
            <ng-content></ng-content>
            {{headertext}}
        </div>
    </div>
  


// WEBPACK FOOTER //
// /app/node_modules/ngx-file-drop/ngx-file-drop.d.ts.FileComponent.html